"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
function insertImage(editor, imageFile) {
    if (typeof imageFile == 'string') {
        insertImageWithSrc(editor, imageFile);
    }
    else {
        roosterjs_editor_dom_1.readFile(imageFile, function (dataUrl) {
            if (dataUrl && !editor.isDisposed()) {
                insertImageWithSrc(editor, dataUrl);
            }
        });
    }
}
exports.default = insertImage;
function insertImageWithSrc(editor, src) {
    editor.addUndoSnapshot(function () {
        var image = editor.getDocument().createElement('img');
        image.src = src;
        image.style.maxWidth = '100%';
        editor.insertNode(image);
    }, "Format" /* Format */);
}
//# sourceMappingURL=insertImage.js.map